import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetBigBlueOrderInfoSchema, GetBigBlueOrderResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetBigBlueOrderResponseDataSchema>>

export function useBigBlueSearchOrderMutation() {
  return useMutation({
    mutationFn: async (data: z.infer<typeof GetBigBlueOrderInfoSchema>) => {
      return axios
        .post<Response>(`/integrations/bigblue/search`, data)
        .then((response) => response.data.data)
    },
  })
}
